module.exports = __webpack_public_path__ + "static/img/top.812c072.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game/top.jpg
// module id = FJ2A
// module chunks = 1